import React from 'react'
import { TabsContext } from './TabsContext'

interface TabsProps {
  currentTab: string | number
  onTabChange: (value: string | number) => void
  children: React.ReactNode
  className?: string
}

function Tabs({ currentTab, onTabChange, children, className }: TabsProps) {
  return (
    <TabsContext.Provider value={{ currentTab, onTabChange }}>
      <Flex $gap='sm' className={className}>
        {children}
      </Flex>
    </TabsContext.Provider>
  )
}

export default Tabs
